import React, { useEffect, useRef, useState } from "react";
import LandingPageLayout, {
  Header,
} from "../../shared/Layouts/LandingPageLayout";
import { motion } from "framer-motion";

import { Tooltip } from "@mui/material";
import { FRAME_1, FRAME_2, FRAME_3 } from "../../assets";
import { useNavigate } from "react-router-dom";

function Hero() {
  const [current, setCurrent] = useState(0);

  const images = [FRAME_1, FRAME_2, FRAME_3];

  const [direction, setDirection] = useState(1); // 1 for forward, -1 for backward

  useEffect(() => {
    const interval = setInterval(() => {
      setDirection(1);
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const swipeVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? "100%" : "-100%",
      opacity: 0,
      position: "absolute",
    }),
    center: {
      x: 0,
      opacity: 1,
      position: "absolute",
    },
    exit: (direction: number) => ({
      x: direction > 0 ? "-100%" : "100%",
      opacity: 0,
      position: "absolute",
    }),
  };
  return (
    <div
      id="hero-section"
      className="w-full relative lg:h-screen h-[500px] sm:h-[600px] overflow-hidden"
    >
      <div className="w-full h-full absolute inset-0">
        <motion.img
          key={images[current]}
          src={images[current]}
          custom={direction}
          // @ts-ignore
          variants={swipeVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { type: "spring", stiffness: 100, damping: 20 },
            opacity: { duration: 0.5 },
          }}
          className="w-full h-full object-cover"
          alt={`Hero image ${current + 1}`}
        />
      </div>
      <div className="absolute inset-0 bg-[#00000099] z-10"></div>

      <Header />
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        className="absolute flex-col gap-y-3 sm:gap-y-4 inset-0 lg:mt-7 mt-16 sm:mt-20 flex z-40 items-center text-white justify-center px-4 sm:px-8 lg:px-20"
      >
        <span className="text-2xl sm:text-3xl lg:text-[43px] font-bold text-center lg:leading-[50px] leading-[32px] sm:leading-[40px] max-w-4xl">
          Enugu State Customary <br /> Court of Appeal
        </span>
        <p className="text-sm sm:text-base lg:text-lg font-medium text-center max-w-4xl leading-relaxed">
          The Enugu State Customary Court of Appeal is committed to the fair and
          timely adjudication of customary law matters, providing justice
          in accordance with the traditions, customs, and laws of the
          people of Enugu State.
        </p>
      </motion.div>
    </div>
  );
}

export default Hero;
